import styled from "@emotion/styled";

export const Button = styled.button`
  display: flex;
  flex: 1 0 0;
  gap: 10px;
  justify-content: center;
  align-items: center;

  max-inline-size: 140px;
  padding-block: 8px;
  padding-inline: 12px;

  color: #ffffff;

  border-radius: 2px;

  background: #4585ff;

  cursor: pointer;
`;
